import CanvasSVG from './CanvasSVG';

export default CanvasSVG;
